
export function getDate(date) {
    if(date == null){
        return new Date();
    }
    
    return new Date(date);
}
